import { Component, OnInit } from '@angular/core';
import { Empty_Salary_Ezafekar_Interface, Salary_Ezafekar_Interface } from 'src/app/Interface/Salary_Ezafekar_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SalaryService } from 'src/app/Service/Salary/Salary.service';

@Component({
  selector: 'app-SalaryDayList',
  templateUrl: './SalaryDayList.component.html',
  styleUrls: ['./SalaryDayList.component.scss']
})
export class SalaryDayListComponent implements OnInit {

 Token: String = ""
  Filter_title: string = ""
  Filter_year: string = "1404"
  Filter_month: string = "1"
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private Salary_Service: SalaryService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
  ) { }


  DataList_Salary: Array<any> = []


  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 2232).subscribe(
      data => {
        this.ReadData_Salary()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_Salary() {
    this.Procssing = true
    this.Salary_Service.GetDay(this.Token, Number(this.Filter_year), Number(this.Filter_month)).subscribe(
      data => {
        this.DataList_Salary = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title() {
    this.page = 0
  }

  SubmitAddNewSalary(model: any) {
    var Record: Salary_Ezafekar_Interface = Empty_Salary_Ezafekar_Interface()
    Record.year = Number(this.Filter_year)
    Record.month = Number(this.Filter_month)
    Record.id = 0
    Record.ezafekar = Number(model.ezakekarCount)
    Record.person_id = Number(model.personId)




    this.Procssing = true
    this.Salary_Service.AddDay(Record, this.Token).subscribe(
      data => {
        this.Procssing = false
        this.Alertify_Service.SuccessMessage("Information saved successfully.")
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

}
